const LeadsStorage = {
  state: {
    viewLeadsSidebar: false,
    singleLeadDeleteLeads: null,
    viewleadsSidebarData: null,
    toggleData: {
      row_details:null,
      toggle: null
    },
    leads_active_status: []
  },
  mutations: {
    SET_DELETE_ID_MUTATION: (state, payload) => {
      state.singleLeadDeleteLeads = payload
    },
    SET_LEADS_VIEW_SIDEBAR_MUTATION: (state, payload) => {
      state.viewLeadsSidebar = payload
    },
    SET_LEADS_VIEW_SIDEBAR_DATA_MUTATION: (state, payload) => {
      state.viewleadsSidebarData = payload
    },
    SET_LEADS_TOGGLE_DATA_MUTATION: (state, payload) => {
      state.toggleData.row_details = payload.row_details
      state.toggleData.toggle = payload.toggle
    },
    SET_LEADS_ACTIVE_STATUS_MUTATION: (state, payload) => {
      state.leads_active_status = payload
    }
  },
  actions: {
    SET_DELETE_ID:({commit}, payload) => {
      commit('SET_DELETE_ID_MUTATION', payload)
    },
    SET_VIEW_LEADS_SIDEBAR: ({commit}, payload) => {
      commit('SET_LEADS_VIEW_SIDEBAR_MUTATION', payload)
    },
    SET_VIEW_LEADS_SIDEBAR_DATA: ({commit}, payload) => {
      commit('SET_LEADS_VIEW_SIDEBAR_DATA_MUTATION', payload)
    },
    SET_LEADS_TOGGLE_DATA: ({commit}, payload) => {
      commit('SET_LEADS_TOGGLE_DATA_MUTATION', payload)
    },
    SET_LEADS_ACTIVE_STATUS: ({commit}, payload) => {
      commit('SET_LEADS_ACTIVE_STATUS_MUTATION', payload)
    }
  },
  getters: {
    get_leads_deleted_id: (state) => {
      return state.singleLeadDeleteLeads
    },
    get_leads_sidebar_view: (state) => {
      return state.viewLeadsSidebar
    },
    get_leads_sidebar_data: (state) => {
      
      return state.viewleadsSidebarData
    },
    get_leads_toggle_data:(state) => {
      return state.toggleData
    },
    get_active_status_list: (state) => {
      return state.leads_active_status
    }
  }
}
export default LeadsStorage
